<script>
	import Menu from './Menu.svelte';
	import MenuOption from './MenuOption.svelte';
	import MenuDivider from './MenuDivider.svelte';
	import { tick } from 'svelte'
	
	import Icon from './Icon.svelte'
	
	let pos = { x: 0, y: 0 };
	let showMenu = false;
	export let goSetting = console.log;
	export let goDashboard = console.log;
	export let goHack = console.log;
	
	async function onRightClick(e) {
		if (showMenu) {
			showMenu = false;
			await new Promise(res => setTimeout(res, 100));
		}
		
		pos = { x: e.clientX, y: e.clientY };
		showMenu = true;
	}
	
	function closeMenu() {
		showMenu = false;
	}
</script>

{#if showMenu}
	<Menu {...pos} on:click={closeMenu} on:clickoutside={closeMenu}>
		<MenuOption 
			on:click={goSetting} 
			text="설정" />
		<MenuOption 
			on:click={goDashboard} 
			text="상황판" />
		<MenuDivider />
		<MenuOption 
			on:click={goHack} 
			text="수량입력" />
		<MenuOption on:click={() => document.documentElement.requestFullscreen()}>
			<span>전체화면</span>
		</MenuOption>
	</Menu>
{/if}

<svelte:body on:contextmenu|preventDefault={onRightClick} />